import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class DateFixService {
  getDateString(date: Date | string): string {
    const dateTime = date instanceof Date ? DateTime.fromJSDate(date) : this.parseDateString(date);

    return dateTime.toFormat("yyyy-MM-dd'T'HH:mm:ss");
  }

  private parseDateString(date: string): DateTime {
    const isoDate = DateTime.fromISO(date);
    if (isoDate.isValid) {
      return isoDate;
    }

    return DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm');
  }
}
